angular.module('FlexyBeautyApp.services')
    .factory('TimeMeasures', function () {
        return {
            MODEL_GLOBAL_TIME: "A - MODEL_GLOBAL_TIME",
            MODEL_GLOBAL_TIME_STARTUP: "A - MODEL_GLOBAL_TIME_STARTUP",
            MODEL_LOADING: "A-1 - MODEL_LOADING",
            CUSTOMERS_LOADING: "A-1-a - CUSTOMERS_LOADING",
            DELETED_CUSTOMERS_LOADING: "A-1-b - DELETED_CUSTOMERS_LOADING",
            DAYS_LOADING: "A-1-c - DAYS_LOADING",
            BACKOFFICE_DEPENDENCIES_LOADING: "A-2-a - BACKOFFICE_DEPENDENCIES_LOADING",
            RESOURCE_DAYS_LOADING: "A-2-b - RESOURCE_DAYS_LOADING",
            DAYS_DEPENDENCIES_LOADING: "A-2-c - DAYS_DEPENDENCIES_LOADING",
            LANGUAGE_MANAGER_INITIALISATION: "A-1-e - LANGUAGE_MANAGER_INITIALISATION",
            LANGUAGE_MANAGER_SET_LOCALE: "A-1-e-1 - LANGUAGE_MANAGER_SET_LOCALE",
            LANGUAGE_MANAGER_LOAD_MOMENT: "A-1-e-2 - LANGUAGUE_MANAGER_LOAD_MOMENT",
            LANGUAGE_MANAGER__LOAD_GOOGLE_CHARTS: "A-1-e-3 - LANGUAGE_MANAGER__LOAD_GOOGLE_CHARTS",
            LANGUAGE_MANAGER_LOAD_ANGULAR: "A-1-e-4 - LANGUAGE_MANAGER_LOAD_ANGULAR",
            LANGUAGE_MANAGER_LOAD_DICTIONARY: "A-1-e-5 - LANGUAGE_MANAGER_LOAD_DICTIONARY",
            LANGUAGE_MANAGER_SET_NUMBER_FORMATTER: "A-1-e-6 - LANGUAGE_MANAGER_SET_NUMBER_FORMATTER",
            INIT_COMPANY_VIEW: "A-3-b - INIT_COMPANY_VIEW",
            EXTERNAL_SERVICES_LOADING: "A-3-c - EXTERNAL_SERVICES_LOADING",
            INIT_NOTIFICATION_VIEW: "A-3-d - INIT_NOTIFICATION_VIEW",
            PLANNING_POS_GLOBAL_TIME: "B - PLANNING_POS_GLOBAL_TIME",
            PLANNING_POS_GLOBAL_TIME_STARTUP: "B - PLANNING_POS_GLOBAL_TIME_STARTUP",
            AFTER_LOADING_STARTUP_REMAINING_TIME: "C - AFTER_LOADING_STARTUP_REMAINING_TIME",
            POS_PARAM: "B-1-a - POS_PARAM",
            CUSTOMER_PARAM: "B-1-b - CUSTOMER_PARAM",
            VATS_VIEW: "B-1-c - VATS_VIEW",
            OTHER_PAYMENT_TYPES_VIEW: "B-1-d - OTHER_PAYMENT_TYPES_VIEW",
            CATEGORY_VIEW: "B-1-e - CATEGORY_VIEW",
            SUPPLIER_VIEW: "B-1-f - SUPPLIER_VIEW",
            PRODUCT_CATEGORY_VIEW: "B-1-g - PRODUCT_CATEGORY_VIEW",
            CURE_CATEGORY_VIEW: "B-1-h - CURE_CATEGORY_VIEW",
            LOYALTY_CARD_CATEGORY_VIEW: "B-1-i - LOYALTY_CARD_CATEGORY_VIEW",
            PHYSICAL_RESOURCES_VIEW: "B-1-j - PHYSICAL_RESOURCES_VIEW",
            HUMAN_RESOURCES_VIEW: "B-1-k - HUMAN_RESOURCES_VIEW",
            CUSTOMERS_VIEW: "B-1-l - CUSTOMERS_VIEW",
            CUSTOMERS_VIEW_DISPLAYED: "B-1-m - CUSTOMERS_VIEW_DISPLAYED",
            CUSTOMERS_DELETED_VIEW: "B-1-n - CUSTOMERS_DELETED_VIEW",
            CUSTOMERS_DELETED_VIEW_DISPLAYED: "B-1-o - CUSTOMERS_DELETED_VIEW_DISPLAYED",
            SMS_CAMPAIGN_LIST_VIEWS: "B-1-p - SMS_CAMPAIGN_LIST_VIEWS",
            NOTIF_CAMPAIGN_LIST_VIEWS: "B-1-q - NOTIF_CAMPAIGN_LIST_VIEWS",
            INIT_SUB_VIEWS: "B-2-a - INIT_SUB_VIEWS",
            TIMELINE_AND_ACTIVITY_IS_PAST: "B-2-b - TIMELINE_AND_ACTIVITY_IS_PAST",
            ADD_SALE_VIEW_NOW: "B-2-c - ADD_SALE_VIEW_NOW",
            USER_ACTION_FROM_DATE: "D-1 - USER_ACTION_FROM_DATE",
            USER_ACTION_BOOKING: "D-2 - USER_ACTION_BOOKING",
            PLANNING_DAY_OPENINGS_RESPONSE_TREATMENT: "PLANNING_DAY_OPENINGS_RESPONSE_TREATMENT"
        };
    })
    .factory('CountMeasures', ['MeasureStore', function (MeasureStore) {
        let measures = {
            NUMBER_STILL_DAY_TO_LOAD: "A-1-d - NUMBER_STILL_DAY_TO_LOAD"
        };
        for(let measure in measures){
            MeasureStore.initCounter(measures[measure]);
        }
        return measures;
    }])
    .factory('TimeValues', function () {
        return {
            START: "START",
            END: "END",
            DURATION: "DURATION",
            COUNT: "COUNT"
        };
    })
    .factory('MeasureStore', ["TimeValues", "moment", function (TimeValues, moment) {
        let measureStore = {};

        measureStore.initCounter = function (measure) {
            if (!this[measure]) {
                this[measure] = {};
            }
            this[measure][TimeValues.COUNT] = 0;
            console.info("Measure : \"" + measure + "\"; New value : " + this[measure][TimeValues.COUNT] + "");

        };

        measureStore.registerCount = function (measure) {
            if (!this[measure]) {
                this[measure] = {};
            }
            this[measure][TimeValues.COUNT]++;
            console.info("Measure : \"" + measure + "\"; New value : " + this[measure][TimeValues.COUNT] + "");

        };

        measureStore.registerStart = function (measure) {
            if (!this[measure]) {
                this[measure] = {};
            }
            if(!this[measure][TimeValues.START]){
                this[measure][TimeValues.START] = Date.now();
            }
        };

        measureStore.registerEnd = function (measure) {
            if (!this[measure]) {
                this[measure] = {};
            }
            if(!this[measure][TimeValues.END]) {
                this[measure][TimeValues.END] = Date.now();
                this[measure][TimeValues.DURATION] = this[measure][TimeValues.END] - this[measure][TimeValues.START];
                console.info("Measure : \"" + measure + "\"; duration : " + this[measure][TimeValues.DURATION] + " ms");
            }
        };
        return measureStore;
    }])
    .factory('Decorators', ['MeasureStore', function (MeasureStore) {
        return {
            timeMeasureDecorator: function timeMeasureDecorator(fn, measureName) {
                if (typeof fn !== 'function') {
                    console.warn("Invalid usage of decorator \"timeMeasureDecorator\". " + fn + " is not a function.");
                    return fn;
                }
                else {
                    let measureNameChoosen = measureName ? measureName : (fn.name ? fn.name : null);

                    return function (...args) {
                        if (measureNameChoosen) {
                            MeasureStore.registerStart(measureName);
                        }
                        let result = fn.call(this, ...args);
                        if (result && typeof result.then === 'function') {
                            return result.then(
                                    (data) => {
                                        if (measureNameChoosen) {
                                            MeasureStore.registerEnd(measureName);
                                        }
                                        return data;
                                    }
                            );
                        } else {
                            if (measureNameChoosen) {
                                MeasureStore.registerEnd(measureName);
                            }
                        }
                    }
                }
            }
        };
    }]);


// WEBPACK FOOTER //
// ./js/services/aspect/TimeAspect.js